'use strict';

var _handlebarsMin = require('handlebars/dist/handlebars.min.js');

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('jquery-sticky-kit/dist/sticky-kit.min.js');

var defaultProductSort;

$(document).ready(function () {

	document.addEventListener('lazybeforeunveil', function (e) {
		var bg = e.target.getAttribute('data-bg');
		if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});

	var searchTerms = $('.search-header').data('search-terms');
	var productCount = $('.search-header').data('search-count');
	var pageCount = Math.ceil(productCount / 250);
	var allTags = new Array();
	var allVendors = new Array();
	var count = 0;
	if (productCount > 0) {
		$('.collection-grid .loading-spinner').show();
	}
	for (var i = 0; i < pageCount; i++) {
		var page = i + 1;
		$.getJSON('/search?view=json&type=product&q=' + searchTerms + '&page=' + page, function (response) {
			defaultProductSort = response;
			var defaultSort = 1;
			$.each(response, function (i, product) {
				var source = document.getElementById("product_grid_item").innerHTML;
				var template = _handlebarsMin2.default.compile(source);
				var productDate = new Date(product.created_at);
				var productTags = $.map(product.tags, function (n, i) {
					return Shopify.handleize(n);
				});
				var productVendor = Shopify.handleize(product.vendor);
				var context = {
					default_sort: defaultSort,
					product_url: '/products/' + product.handle,
					product_title: product.title,
					product_img: product.featured_image.replace('.jpg', '_large.jpg'),
					product_price_filter: product.variants[0].price / 100,
					product_price: formatCurrency(product.variants[0].price / 100),
					product_tags: productTags.join(' '),
					product_date: productDate.getTime() / 1000,
					product_vendor: productVendor
				};
				var html = template(context);
				$(html).appendTo('#product-grid').removeClass('hidden');
				defaultSort++;
				allTags = unique($.merge($.merge([], allTags), product.tags));
				allVendors.push(product.vendor);
				allVendors = unique(allVendors);
			});
		}).always(function () {
			// Fires when AJAX is complete.		

			count++;

			if (count == pageCount) {
				// due to pagination, only run if this is the last page AJAX call.

				$('.collection-grid .loading-spinner').fadeOut();

				// Materials

				var allMaterialsForHandlebars = new Array();
				$.each(allTags, function (i, tag) {
					if (tag.indexOf("material-") >= 0) {
						var obj = {
							filter_category_handle: 'tag',
							filter_name_handle: Shopify.handleize(tag),
							filter_name: tag.replace('material-', '').replace('-', ' ')
						};
						allMaterialsForHandlebars.push(obj);
					}
				});
				var filterData = {
					filter_category: 'Materials',
					filter_category_handle: 'tag',
					filters: allMaterialsForHandlebars
				};
				var source = document.getElementById("filter_section").innerHTML;
				var template = _handlebarsMin2.default.compile(source);
				var html = template(filterData);
				$(html).appendTo('.collection-filters');

				// Vendors

				var allVendorsForHandlebars = new Array();
				$.each(allVendors, function (i, vendor) {
					var obj = {
						filter_category_handle: 'brand',
						filter_name_handle: Shopify.handleize(vendor),
						filter_name: vendor
					};
					allVendorsForHandlebars.push(obj);
				});
				var filterData = {
					filter_category: 'Brands',
					filter_category_handle: 'brand',
					filters: allVendorsForHandlebars
				};
				var source = document.getElementById("filter_section").innerHTML;
				var template = _handlebarsMin2.default.compile(source);
				var html = template(filterData);
				$(html).appendTo('.collection-filters');

				// Tag

				var allTagsForHandlebars = new Array();
				$.each(allTags, function (i, tag) {
					if (tag.indexOf("material-") < 0) {
						var obj = {
							filter_category_handle: 'tag',
							filter_name_handle: Shopify.handleize(tag),
							filter_name: tag
						};
						allTagsForHandlebars.push(obj);
					}
				});
				var filterData = {
					filter_category: 'Tags',
					filter_category_handle: 'tag',
					filters: allTagsForHandlebars
				};
				var source = document.getElementById("filter_section").innerHTML;
				var template = _handlebarsMin2.default.compile(source);
				var html = template(filterData);
				$(html).appendTo('.collection-filters');
			}
		});
	}

	$('.collection-sort-by a').on('click', function (e) {
		e.preventDefault();
		var sort = $(this).data('sort-by');

		if ($(this).hasClass('active')) {
			// Don't do anything if this is already the active sort.
			return false;
		}

		$('.collection-sort-by a').removeClass('active');
		$(this).addClass('active');

		// Sorting logic
		var products = $('.pgi');
		if (sort == 'default') {
			products.sort(function (a, b) {
				return $(a).data("default-sort") - $(b).data("default-sort");
			});
			$("#product-grid").html(products);
		} else if (sort == 'created-descending') {
			products.sort(function (a, b) {
				return $(b).data("date") - $(a).data("date");
			});
			$("#product-grid").html(products);
		} else if (sort == 'price-ascending') {
			products.sort(function (a, b) {
				return $(a).data("price") - $(b).data("price");
			});
			$("#product-grid").html(products);
		} else if (sort == 'price-descending') {
			products.sort(function (a, b) {
				return $(b).data("price") - $(a).data("price");
			});
			$("#product-grid").html(products);
		} else if (sort == 'title-ascending') {
			products.sort(function (a, b) {
				return String.prototype.localeCompare.call($(a).data('product-title').toLowerCase(), $(b).data('product-title').toLowerCase());
			});
			$("#product-grid").html(products);
		} else if (sort == 'title-descending') {
			products.sort(function (a, b) {
				return String.prototype.localeCompare.call($(b).data('product-title').toLowerCase(), $(a).data('product-title').toLowerCase());
			});
			$("#product-grid").html(products);
		} else {
			// Do Nothing
		}

		$(this).closest('.dropdown-options').slideToggle();
	});

	$('body').on('click', '.collection-filter-by-brand a', function (e) {
		e.preventDefault();
		var brandFilter = $(this).data('brand-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-brand a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-brand a').removeClass('active');
		$(this).addClass('active');
		products.each(function (i) {
			if ($(this).data('brand') != brandFilter) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});

	$('body').on('click', '.collection-filter-by-tag a', function (e) {
		e.preventDefault();
		var tagFilter = $(this).data('tag-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-tag a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-tag a').removeClass('active');
		$(this).addClass('active');
		products.each(function (i) {
			if (!$(this).hasClass(tagFilter)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});

	$('.collection-filter-by-price a').on('click', function (e) {
		e.preventDefault();
		var priceFilter = $(this).data('price-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-price a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-price a').removeClass('active');
		$(this).addClass('active');

		var price = priceFilter.replace('under-', '');

		products.each(function (i) {
			if (parseInt($(this).data('price')) > parseInt(price)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});
});

function formatCurrency(total) {
	var neg = false;
	if (total < 0) {
		neg = true;
		total = Math.abs(total);
	}
	return (neg ? "-$" : '$') + parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
}

function unique(array) {
	return $.grep(array, function (el, index) {
		return index === $.inArray(el, array);
	});
}

Shopify.handleize = function (str) {
	str = str.toLowerCase();
	var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
	// For the old browsers
	for (var i = 0; i < toReplace.length; ++i) {
		str = str.replace(toReplace[i], "");
	}
	str = str.replace(/\W+/g, "-");
	if (str.charAt(str.length - 1) == "-") {
		str = str.replace(/-+\z/, "");
	}
	if (str.charAt(0) == "-") {
		str = str.replace(/\A-+/, "");
	}
	return str;
};

_handlebarsMin2.default.registerHelper('list', function (context, options) {
	var ret = "";
	for (var i = 0, j = context.length; i < j; i++) {
		ret = ret + options.fn(context[i]);
	}
	return ret;
});